<form name="form" (ngSubmit)="form.valid && submit()" #form="ngForm" novalidate>
    <div class="modal-header">
        <h3 class="modal-title" id="modal-page-fix-title" translate>PageCorrect Custom Phrase or Word</h3>
    </div>
    <div class="modal-body bg-white page-fix-form-fix" id="modal-page-fix-custom">
        <div class="form-group row">
            <label class="col-sm-8 col-form-label text-bold text-right" for="page_fix_custom_selector" translate>
                Target
            </label>
            <div class="col-sm-40">
                <input type="text" 
                       class="form-control" 
                       required 
                       [(ngModel)]="model.custom_selector" 
                       [name]="'page_fix_custom_selector'"
                       id="page_fix_custom_selector"/>
                <span class="form-text text-muted" translate>Please specify word or phrase to search for</span>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-8 text-bold text-right" for="page_fix_custom_word" translate>Word or Phrase</label>
            <div class="col-sm-40">
                <input class="form-control" 
                       type="text" 
                       id="page_fix_custom_word" 
                       [(ngModel)]="model.change.value" 
                       [name]="'page_fix_custom_word'"
                       required/>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button data-test="cancel-button" 
                class="btn btn-border-radius btn-secondary" 
                type="button" 
                (click)="cancel()" 
                translate>
            Cancel
        </button>
        <button data-test="save-button" 
                class="btn btn-border-radius btn-marine-blue ml-0" 
                [disabled]="form.invalid" 
                translate>Save</button>
    </div>
</form>
